/**
 * Les identités Twilio du téléphone web (`client:agent_<user>_<company>`,
 * `agent_<user>_<company>`) sont internes : elles ne s'affichent jamais.
 * Partout où un « numéro » peut en être une, on passe par ici.
 */

export function estIdentiteAgent(valeur: string | null | undefined): boolean {
  if (!valeur) return false
  return valeur.startsWith('client:agent_') || (valeur.startsWith('agent_') && !valeur.startsWith('+'))
}

/** L'utilisateur derrière `client:agent_<user>_<company>`, sinon null. */
export function userIdDeIdentite(valeur: string | null | undefined): number | null {
  const m = /^(?:client:)?agent_(\d+)_\d+$/.exec(valeur || '')
  return m ? Number(m[1]) : null
}

interface AppelAvecAgents {
  direction: string
  from_number: string
  to_number: string
  final_destination?: string | null
  target_agent_name?: string | null
  initiator_agent_name?: string | null
  /** Appel interne : le collègue à l'autre bout, vu par la personne connectée. */
  internal_peer_name?: string | null
}

/**
 * Le libellé du correspondant d'un appel : le nom du contact, sinon le
 * numéro, sinon le nom de l'agent quand le correspondant est un poste web.
 * `libelleAgent` est le mot de secours si même le nom manque (« Agent »).
 */
export function libelleCorrespondant(
  appel: AppelAvecAgents,
  nomPourNumero: (numero: string | null | undefined) => string,
  libelleAgent: string,
): string {
  const numero = numeroCorrespondant(appel)
  if (appel.internal_peer_name) return appel.internal_peer_name
  if (!estIdentiteAgent(numero)) return nomPourNumero(numero)
  return appel.target_agent_name || appel.initiator_agent_name || libelleAgent
}

/**
 * Le numéro de la personne au bout du fil. Un click-to-call (API, bouton)
 * fait d'abord sonner l'agent : `to_number` est alors son téléphone, et le
 * client est dans `final_destination`.
 */
export function numeroCorrespondant(appel: {
  direction: string
  from_number: string
  to_number: string
  final_destination?: string | null
}): string {
  if (appel.direction !== 'outbound') return appel.from_number
  return appel.final_destination || appel.to_number
}

/** Un numéro tel quel, ou le mot de secours si c'est une identité interne. */
export function numeroOuLibelle(valeur: string | null | undefined, libelleAgent: string): string {
  return estIdentiteAgent(valeur) ? libelleAgent : (valeur || '')
}
